import * as React from "react";
const SvgFiRrChartConnected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chart-connected_svg__a)">
      <path
        fill="#062147"
        d="M24 11.983a3.995 3.995 0 0 0-2.607-3.735l-.038-.09a10.07 10.07 0 0 0-5.294-5.42l-.33-.144a3.981 3.981 0 0 0-7.461 0l-.418.188a10.2 10.2 0 0 0-5.235 5.463 3.98 3.98 0 0 0-.03 7.468l.128.3a10.1 10.1 0 0 0 5.162 5.228l.393.176a3.982 3.982 0 0 0 7.46 0l.367-.163a10.2 10.2 0 0 0 5.309-5.534A4 4 0 0 0 24 11.983M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M3.988 9.985l.082.031.01-.025a1.912 1.912 0 1 1-.092-.006M12 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m3.893-2.886a3.99 3.99 0 0 0-7.787 0 8.1 8.1 0 0 1-3.231-3.234A3.99 3.99 0 0 0 4.9 8.1a8.2 8.2 0 0 1 3.206-3.2 3.991 3.991 0 0 0 7.785 0A8.23 8.23 0 0 1 19.1 8.093a3.99 3.99 0 0 0 .015 7.785 8.2 8.2 0 0 1-3.222 3.236M20 13.984a2 2 0 1 1 0-4.002 2 2 0 0 1 0 4.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-connected_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartConnected;
